import * as React from "react";

;
export const ArrowUp = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}><path fill="#100722" d="M13.083 6.969V22h-1.5V6.969C10.032 9.355 7.365 11.083 4 11.083v-1.5c4.526 0 7.568-3.762 7.583-7.554V2h1.5c0 3.802 3.046 7.583 7.584 7.583v1.5c-3.366 0-6.032-1.728-7.584-4.114Z" /></svg>;